export default __webpack_public_path__ + "locales/bg/Common.json?hash=0c86920f5d493063fa271f589d630646";